import { render, staticRenderFns } from "./SlidingBayDamageSeverity.vue?vue&type=template&id=0904914c&scoped=true"
import script from "./SlidingBayDamageSeverity.vue?vue&type=script&lang=ts"
export * from "./SlidingBayDamageSeverity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0904914c",
  null
  
)

export default component.exports